<script setup lang="ts">
import type { CustomIcon } from '@/components/common';
import type { PropType } from 'vue';


defineProps({
  icon: {
    type: Object as PropType<CustomIcon>,
    required: true
  },
  title: {
    type: String,
    required: true
  },
  subTitle: {
    type: String,
    required: true
  }
});

const emits = defineEmits(['itemClick']);
const itemClick = () => {
  emits('itemClick');
};
</script>

<template>
    <div class="template-root" v-ripple @click="itemClick">
        <FontAwesomeIcon :icon="[`${icon.style}`, `${icon.icon}`]" class="icon" />
        <h3 class="title">{{ title }}</h3>
        <p class="subtitle">{{ subTitle }}</p>
    </div>
</template>

<style lang="scss" scoped>
@use '../../../assets/variables.module' as *;
.template-root {
    min-width: 276px;
    padding: 24px 36px;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    border: 1px solid rgba($color: #000000, $alpha: 0.12);
    border-radius: 4px;
    cursor: pointer;

    .icon {
        font-size: 48px;
        color: $primary-color;
    }

    .title {
        font-weight: 700;
        margin-top: 24px;
    }

    .subtitle {
        font-weight: 500;
        margin-top: 16px;
    }

    &:hover {
        background-color: rgba($color: #000000, $alpha: 0.1)
    }
}
</style>
